import {Spin} from 'antd';

import './Loading.css';

function Loading() {
  return (
    <div className="Loading">
      <Spin size="large" className="spinner" />
    </div>
  );
}

export default Loading;
